enum CstIBSCBS {
    TributacaoIntegral = 0,
    TributacaoAliquotasUniformesSetorFinanceiro = 10,
    TributacaoAliquotasUniformesReduzidas60 = 11,
    TributacaoAliquotasUniformesReduzidas30 = 12,
    AliquotaZero = 200,
    AliquotaZeroCBSReduzida60IBS = 201,
    AliquotaReduzida80 = 202,
    AliquotaReduzida70 = 203,
    AliquotaReduzida60 = 204,
    AliquotaReduzida50 = 205,
    AliquotaReduzida40 = 206,
    AliquotaReduzida30 = 207,
    AliquotaReduzida50ComRedutorBase = 210,
    AliquotaReduzida70ComRedutorBase = 211,
    AliquotaFixa = 220,
    AliquotaFixaProporcional = 221,
    ReducaoBaseCalculo = 222,
    Isencao = 400,
    ImunidadeNaoIncidencia = 410,
    Diferimento = 510,
    Suspensao = 550,
    TributacaoMonofasica = 620,
    TransferenciaCredito = 800,
    Ajustes = 810,
    TributacaoRegimeEspecifico = 820,
    ExclusaoBaseCalculo = 830,
}

export default CstIBSCBS;
